import { createUseStyles } from 'react-jss'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Card from '../../../Card'
import File from '../../../File'
import { Colors } from '../../../../constants/colors'
import { FileModel, FileType, UpcomingPayroll } from '../../../../redux/types'
import { RootState } from '../../../../redux/store'

interface ImportFilesForPaydayProps {
  upcomingPayroll: UpcomingPayroll
}

const ImportFilesForPayday = ({ upcomingPayroll }: ImportFilesForPaydayProps) => {
  const styles = useStyles()
  const { t } = useTranslation(['common', 'payrolls'])
  const files = useSelector((state: RootState) => state.files.files)

  const isBankAccountImportFile = (file: FileModel) => 
    file.type === FileType.bankAccountFile && upcomingPayroll.payrollCreated

  const isPayoutBasisImportFile = (file: FileModel) =>
    file.type === FileType.deductionPayoutBasisFile &&
    file.deductionPayoutBasisFile?.paydayPaymentDate === upcomingPayroll.paymentDate

  const filesForPayday = files.filter(file => isBankAccountImportFile(file) || isPayoutBasisImportFile(file))

  if (filesForPayday.length === 0) {
    return null
  }

  return (
    <Card className={styles.importFilesContainer}>
      <h6 style={{ marginBottom: 10 }}>{t('importFiles', { ns: 'payrolls' })}</h6>
      {filesForPayday.map((file, index) => {
        return (
          <File file={file} key={`file_${index}`} />
        )
      })}
    </Card>
  )
}

const useStyles = createUseStyles({
  importFilesContainer: {
    backgroundColor: Colors.grayBackgroundStrong,
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20
  }
})

export default ImportFilesForPayday 